import { Col, Divider, Row, Typography } from "antd";
import React, { useMemo } from "react";
import FormatFunction from "../../../../../../shared/utils/Fn";
import { sumPrice } from "../../../../../../shared/utils/Numbers";
import color from "../../../../../../theme/color";

interface ProductOptionsInfoCardFormProps {
  title: React.ReactNode;
  description?: React.ReactNode;
  erpCode?: string;
  unitPrice?: number;
  amount?: number | undefined;
}

/**
 * 상품 세부옵션 정보 카드
 * @param param0
 * @returns
 */
export const ProductOptionsInfoCardForm: React.FC<
  ProductOptionsInfoCardFormProps
> = ({ title, description, erpCode, unitPrice, amount }) => {
  /**
   * 총 금액
   */
  const totalPrice = useMemo(
    () => sumPrice(unitPrice, 0, amount)(true),
    [unitPrice, amount]
  );

  return (
    <Row gutter={[8, 2]} align="middle">
      <Col span={24}>
        <Row justify="space-between" align="middle">
          <Col>
            <Typography.Text strong>{title}</Typography.Text>
          </Col>
          {unitPrice && (
            <Col>
              <Typography.Text strong>{totalPrice}원</Typography.Text>
            </Col>
          )}
        </Row>
      </Col>
      {description && (
        <Col>
          <Typography.Text color={color.gray5}>{description}</Typography.Text>
        </Col>
      )}
      {erpCode && (
        <Col span={24}>
          <Typography.Text style={{ color: color.gray5 }}>
            부품번호 : {erpCode}
          </Typography.Text>
        </Col>
      )}
      {unitPrice && (
        <>
          <Col>
            <Typography.Text style={{ color: color.gray5 }}>
              옵션단가 : {FormatFunction.numFormat(unitPrice) || "-"}원
            </Typography.Text>
          </Col>
          <Col>
            <Divider
              type="vertical"
              style={{
                borderColor: color.gray5,
                lineHeight: "20px",
                margin: 0,
              }}
            />
          </Col>
        </>
      )}
      {amount && (
        <Col>
          <Typography.Text style={{ color: color.gray5 }}>
            수량 : {amount}개
          </Typography.Text>
        </Col>
      )}
    </Row>
  );
};
